import { Signal } from "@angular/core";
import { IBaseDirectory } from "../interfaces/base-directory.interface";
import { Observable } from "rxjs";

export abstract class ActiveDirectoryAbstraction {
  abstract activeDirectory: Signal<IBaseDirectory | null>;
  abstract availableDirectories: Signal<IBaseDirectory[]>;
  abstract changeActiveDirectory(id: string): Observable<IBaseDirectory | null>;
}
